@if (isRyderCup || isMatchPlay) {
  <div style="display: flex; flex-direction: column; width: 100%; height: 100%">
    <div class="sticky-banner">
      <app-sponsor-banner [margin]="'0.6rem 0 0 0'" [location]="'Golf Leaderboard'" [sponsor_key]="'leaders-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner>
    </div>

    <app-golf-team-score-card [golfTour]="golfTour()!"></app-golf-team-score-card>

    <app-golf-match-filter [golfTour]="golfTour()!" [(selected)]="selectedFilter"> </app-golf-match-filter>

    <app-golf-match-cards [golfTour]="golfTour()!" [filter]="selectedFilter"> </app-golf-match-cards>

    @if (isEmpty) {
      <div class="center empty-box">
        <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
        <h2>
          <app-app-string key_name="golf.leaderboard.empty.title"></app-app-string>
        </h2>
        <p>
          <app-app-string key_name="golf.leaderboard.empty.body"></app-app-string>
        </p>
      </div>
    }
  </div>
} @else {
  @if (isEmpty) {
    <div class="center empty-box">
      <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
      <h2>
        <app-app-string key_name="golf.leaderboard.empty.title"></app-app-string>
      </h2>
      <p>
        <app-app-string key_name="golf.leaderboard.empty.body"></app-app-string>
      </p>
    </div>
  }

  @if (!isEmpty) {
    <div style="display: flex; flex-direction: column; width: 100%">
      <div class="sticky-banner">
        <app-sponsor-banner [margin]="'0.6rem 0 0 0'" [location]="'Golf Leaderboard'" [sponsor_key]="'leaders-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner>
      </div>
      @if (strokeEventStatus) {
        <div class="event-status-banner">
          <img class="status-icon" src="assets/golf/exclamationmark.triangle_red.svg" alt="" aria-hidden="true" />
          <span class="status-text">
            {{ statusLabel }}
          </span>
        </div>
      }
      @if (winnerRow) {
        <div class="winner-card">
          <div class="winner-header">
            <app-app-string
              [key_name]="winnerRow.wonViaPlayoff ? 'golf.winner.playoff' : 'golf.winner'">
            </app-app-string>
          </div>
          <div class="winner-body">
            <app-image
              style="cursor: pointer; width: auto;"
              (click)="openPlayer(golf_player)"
              class="winner-photo"
              [display_flag]="true"
              [app_country_flag_width]="'1.4rem'"
              [player]="golf_player"
              [margin]="'0'"
              [width]="'52px'"
              [height]="'52px'"
              [country_flag_left]="'2.8rem'"
              [country_flag_top]="'0.6rem'"
              >
            </app-image>
            <div class="winner-right">
              <div class="name-col">
                <h2 class="winner-name">{{ winnerRow.fullName }}</h2>
              </div>
              <div class="winner-scores-row">
                <div class="rounds-col">
                  @for (val of winnerRow.roundVals; track val; let i = $index) {
                    <span class="round-pair">
                      <span class="round-label">R{{ i + 1 }}</span>
                      <span class="round-score">{{ val }}</span>
                    </span>
                  }
                </div>
                <div class="total-col">
                  <span class="label">
                    <app-app-string key_name="golf.winner.total"></app-app-string>
                  </span>
                  <span class="value">{{ winnerRow.tot }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <app-golf-scorecard></app-golf-scorecard>
    </div>
  }
}

<!-- <div *ngIf="isRyderCup || isMatchPlay; else strokeBlock" style="display: flex; flex-direction: column; width: 100%; height: 100%">
<div class="sticky-banner">
  <app-sponsor-banner [margin]="'0.6rem 0 0 0'" [location]="'Golf Leaderboard'" [sponsor_key]="'leaders-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner>
</div>

<app-golf-team-score-card [golfTour]="golfTour()!"></app-golf-team-score-card>

<app-golf-match-filter [golfTour]="golfTour()!" [(selected)]="selectedFilter"> </app-golf-match-filter>

<app-golf-match-cards [golfTour]="golfTour()!" [filter]="selectedFilter"> </app-golf-match-cards>

<div *ngIf="isEmpty" class="center empty-box">
  <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
  <h2>
    <app-app-string key_name="golf.leaderboard.empty.title"></app-app-string>
  </h2>
  <p>
    <app-app-string key_name="golf.leaderboard.empty.body"></app-app-string>
  </p>
</div>
</div> -->

<!-- <ng-template #strokeBlock>
<div *ngIf="isEmpty" class="center empty-box">
  <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
  <h2>
    <app-app-string key_name="golf.leaderboard.empty.title"></app-app-string>
  </h2>
  <p>
    <app-app-string key_name="golf.leaderboard.empty.body"></app-app-string>
  </p>
</div>

<div *ngIf="!isEmpty" style="display: flex; flex-direction: column; width: 100%">
  <div class="sticky-banner">
    <app-sponsor-banner [margin]="'0.6rem 0 0 0'" [location]="'Golf Leaderboard'" [sponsor_key]="'leaders-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner>
  </div>

  <div *ngIf="strokeEventStatus" class="event-status-banner">
    <img class="status-icon" src="assets/golf/exclamationmark.triangle_red.svg" alt="" aria-hidden="true" />
    <span class="status-text">
      {{ statusLabel }}
    </span>
  </div>

  <div *ngIf="winnerRow" class="winner-card">
    <div class="winner-header">
      <app-app-string key_name="golf.winner"></app-app-string>
    </div>

    <div class="winner-body">
      <app-image
        style="cursor: pointer"
        (click)="openPlayer(golf_player)"
        class="winner-photo"
        [display_flag]="true"
        [app_country_flag_width]="'1.4rem'"
        [player]="golf_player"
        [margin]="'0'"
        [width]="'52px'"
        [height]="'52px'"
        [country_flag_left]="'2.8rem'"
        [country_flag_top]="'0.6rem'"
        >
      </app-image>

      <div class="name-col">
        <h2 class="winner-name">{{ winnerRow.fullName }}</h2>
      </div>

      <div class="rounds-col">
        <ng-container *ngFor="let val of winnerRow.roundVals; let i = index">
          <span class="round-pair">
            <span class="round-label">R{{ i + 1 }}</span>
            <span class="round-score">{{ val }}</span>
          </span>
        </ng-container>
      </div>

      <div class="total-col">
        <span class="label">
          <app-app-string key_name="golf.winner.total"></app-app-string>
        </span>
        <span class="value">{{ winnerRow.tot }}</span>
      </div>
    </div>
  </div>

  <div style="overflow: auto">
    <app-golf-scorecard></app-golf-scorecard>
  </div>
</div>
</ng-template> -->
